import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-471ee01d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 0,
  class: "controls"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center"
}
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " To join a faction, you must have an invite link or an invite code. ", -1))
const _hoisted_8 = { class: "flex flex-col items-center justify-center gap-y-2" }
const _hoisted_9 = { class: "px-2 py-1 text-white border rounded cursor-pointer border-primary bg-primary hover:bg-primary-dark" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Add Image + ")
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col gap-y-2"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Card Only Faction Settings", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" A "),
  /*#__PURE__*/_createElementVNode("i", null, "Card Only Faction"),
  /*#__PURE__*/_createTextVNode(" is for tracking a single scorecard. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Users will not be able to join this faction once the scorecard locks. ")
], -1))

import Button from '@/components/UI/Button.vue';
import { useFactionsStore } from '@/store/factions';
import { computed, inject, onMounted, provide, Ref, ref } from 'vue';
import Modal from '@/components/Modal/Modal.vue';
import TextField from '@/components/Inputs/TextField.vue';
import { Faction, FactionPrivacy } from '@/typings/faction';
import { useUserStore } from '@/store/users';
import Checkbox from '../../components/Inputs/Checkbox.vue';
import { useScorecardStore } from '@/store/scorecards';
import { FactionPayload } from '@/typings/api/factions';
import Dropdown from '@/components/Inputs/Dropdown.vue';
import { AlertModal } from '@/typings/modal';
import LimitedFactions from './LimitedFactions.vue';
import ConstantFactions from './ConstantFactions.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const visibleTab = ref(0);

const store = useFactionsStore();
const userStore = useUserStore();
const scorecardStore = useScorecardStore();

const isPublicView = !userStore.user;
provide('isPublicView', isPublicView);

const factions = computed(() =>
  [...store.publicFactions, ...store.privateFactions].filter(
    (faction) => faction.EventCount === 0
  )
);
const limitedFactions = computed(() =>
  [...store.publicFactions, ...store.privateFactions].filter(
    (faction) => faction.EventCount > 0
  )
);

const cards = computed(() =>
  scorecardStore.scorecards
    .filter((card) => ['Scheduled', 'Open'].includes(card.Status))
    .map((card) => ({
      text: card.Title,
      value: card.EventId,
    }))
    .reverse()
);

const joiningModalVisible = ref(false);
const joiningCode = ref('');
const joiningFaction = ref<Faction | null>(null);
const joiningError = ref('');

async function openJoinModal(faction?: Faction) {
  if (faction?.Privacy === FactionPrivacy.Public) {
    await store.joinPublic(faction);
  } else {
    joiningFaction.value = faction || null;
    joiningModalVisible.value = true;
  }
}

async function joinFaction() {
  if (joiningCode.value.trim()) {
    let success = false;
    if (
      joiningFaction.value &&
      joiningFaction.value.Privacy === FactionPrivacy.InviteOnly
    ) {
      success = await store.joinInviteOnly(
        joiningFaction.value,
        joiningCode.value
      );
    } else if (
      joiningFaction.value &&
      joiningFaction.value.Privacy === FactionPrivacy.Public
    ) {
      success = await store.joinPublic(joiningFaction.value);
    } else {
      success = await store.joinPrivate(joiningCode.value);
    }
    if (success) {
      joiningCode.value = '';
      joiningModalVisible.value = false;
      alertModal.value.show(
        'Faction Joined',
        'You successfully joined a faction.'
      );
    } else {
      joiningError.value = 'This code might not be valid!';
    }
  } else {
    joiningError.value = 'Cannot be empty!';
  }
}

const creatingModalVisible = ref(false);
const creatingFactionEvents = ref<string[]>([]);
const creatingFaction = ref<FactionPayload>({
  Name: '',
  Description: '',
  Events: [],
});
const cardOnly = ref(false);
const creatingError = ref('');

async function openCreateFactionModal() {
  creatingFaction.value = {
    Name: '',
    Description: '',
    Events: [],
  };
  creatingModalVisible.value = true;
}

const file = ref<HTMLInputElement | null>(null);

function imageChanged() {
  if (file.value && file.value.files && creatingFaction.value) {
    const uploaded = file.value.files[0];
    creatingFaction.value.Image = uploaded;
    const reader = new FileReader();
    reader.onloadend = () => {
      const element = document.querySelector('.image') as HTMLDivElement;
      if (element && element.style) {
        element.style.backgroundImage = `url(${reader.result})`;
      }
    };
    reader.readAsDataURL(uploaded);
  }
}

const alertModal = inject('alertModal') as Ref<AlertModal>;

async function createFaction() {
  creatingFaction.value.Events = creatingFactionEvents.value.map((e) =>
    parseInt(e, 10)
  );
  await store.addFaction(creatingFaction.value);
  await store.getFactions();
  creatingModalVisible.value = false;
  alertModal.value.show(
    'Faction Founded',
    'You successfully created a faction.'
  );
}

onMounted(() => {
  store.getFactions();
  scorecardStore.getScorecards();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!isPublicView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(Button, {
              class: "w-40 text-sm",
              label: "Create Faction",
              onClick: openCreateFactionModal
            }),
            _createVNode(Button, {
              class: "w-40 text-sm",
              type: "secondary",
              label: "Join with Code",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openJoinModal()))
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, " To take part in leaderboards with Factions like those below, create an account or login. ")),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (visibleTab.value = 0)),
          class: _normalizeClass(["tab", { selected: visibleTab.value === 0 }])
        }, " Factions ", 2),
        (!isPublicView)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (visibleTab.value = 1)),
              class: _normalizeClass(["tab", { selected: visibleTab.value === 1 }])
            }, " Time-Limited Factions ", 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (visibleTab.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(ConstantFactions, {
                factions: _unref(factions),
                public: isPublicView
              }, null, 8, ["factions"])
            ]))
          : _createCommentVNode("", true),
        (visibleTab.value === 1 && !isPublicView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(LimitedFactions, {
                factions: _unref(limitedFactions),
                public: isPublicView
              }, null, 8, ["factions"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (joiningModalVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: "Join a Faction",
          onClose: _cache[5] || (_cache[5] = ($event: any) => (joiningModalVisible.value = false))
        }, {
          footer: _withCtx(() => [
            _createVNode(Button, {
              label: "Join",
              onClick: joinFaction
            }),
            _createVNode(Button, {
              label: "Cancel",
              type: "secondary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (joiningModalVisible.value = false))
            })
          ]),
          default: _withCtx(() => [
            _hoisted_7,
            _createVNode(TextField, {
              modelValue: joiningCode.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((joiningCode).value = $event)),
              "validation-error": joiningError.value,
              title: "Code"
            }, null, 8, ["modelValue", "validation-error"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (creatingFaction.value && creatingModalVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 1,
          header: "Create a Faction",
          onClose: _cache[11] || (_cache[11] = ($event: any) => (creatingModalVisible.value = false))
        }, {
          footer: _withCtx(() => [
            _createVNode(Button, {
              label: "Join",
              onClick: createFaction
            }),
            _createVNode(Button, {
              label: "Cancel",
              type: "secondary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (creatingModalVisible.value = false))
            })
          ]),
          default: _withCtx(() => [
            _createVNode(TextField, {
              modelValue: creatingFaction.value.Name,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((creatingFaction.value.Name) = $event)),
              "validation-error": joiningError.value,
              title: "Name",
              "max-length": 36
            }, null, 8, ["modelValue", "validation-error"]),
            _createVNode(TextField, {
              modelValue: creatingFaction.value.Description,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((creatingFaction.value.Description) = $event)),
              "validation-error": joiningError.value,
              title: "Description",
              "max-length": 200,
              multiline: ""
            }, null, 8, ["modelValue", "validation-error"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "w-40 h-40 bg-cover border-2 rounded-full image border-primary",
                style: _normalizeStyle({
          'background-image': 'url()',
        })
              }, null, 4),
              _createElementVNode("label", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("input", {
                  class: "hidden",
                  ref: (_value, _refs) => {
                    _refs['file'] = _value
                    file.value = _value
                  },
                  type: "file",
                  onChange: imageChanged
                }, null, 544)
              ])
            ]),
            (_unref(userStore).user?.PrivilegeId === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14,
                  _createVNode(Checkbox, {
                    title: "Make a Card Only Faction",
                    modelValue: cardOnly.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((cardOnly).value = $event))
                  }, null, 8, ["modelValue"]),
                  (cardOnly.value && creatingFaction.value.Events)
                    ? (_openBlock(), _createBlock(Dropdown, {
                        key: 0,
                        title: "Scorecard",
                        modelValue: creatingFactionEvents.value[0],
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((creatingFactionEvents.value[0]) = $event)),
                        items: _unref(cards),
                        "validation-error": creatingError.value
                      }, null, 8, ["modelValue", "items", "validation-error"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})